import { axios } from '@/services/axios';

const getAllWholesalers = async () => {
    const response = await axios.get('/wholesalers/');
    return response.data;
};

export default getAllWholesalers;
